import alosiaSvg from "./team/alosia.svg";
import rohitImg from "./team/rohit.jpeg";
import sidIMG from "./team/sid.jpeg";

export const SalesTeamData = [
  {
    name: "Alosia rose",
    position: "Marketing Head",
    mobileNo: "+91-9847536687",
    mailId: "alosia.rose@deskala.in",
    img: alosiaSvg
  },
  {
    name: "Rohit Solanki",
    position: "Tech Support Head",
    mobileNo: "+91-8878183433",
    mailId: "rohit.solanki@deskala.in",
    img: rohitImg
  },
  {
    name: "Sidhardh Balaji",
    position: "Branding Strategy",
    mobileNo: "+91-7907515393",
    mailId: "sidhardh.balaji@deskala.in",
    img: sidIMG
  },
];
